// hooks/use-oc-app-bar.ts
import { useState } from "react";
import { useMyHrEmployee as useEmployeeDI } from "my-hr/hooks";
import {
  useOcCurrentUserState as useCurrentUserStateDI,
  useOcGetVersion as useGetVersionDI,
  useOcIsMobile,
  useOcProperty,
} from "oc/hooks";

interface UseOcAppBarProps {
  useGetVersion?: typeof useGetVersionDI;
  useCurrentUserState?: typeof useCurrentUserStateDI;
  useEmployee?: typeof useEmployeeDI;
}

export const useOcAppBar = ({
  useGetVersion = useGetVersionDI,
  useCurrentUserState = useCurrentUserStateDI,
  useEmployee = useEmployeeDI,
}: UseOcAppBarProps = {}) => {
  const isMobile = useOcIsMobile();
  const { employeeCode } = useCurrentUserState();
  const { data: employeeData } = useEmployee({ employeeId: employeeCode });

  const [enabled, setEnabled] = useState(true);

  const {
    hasToRefresh,
    timeToRefreshValue,
    showRefreshDialog,
    onRefresh,
    currentVersion,
  } = useGetVersion();

  const onCompleted = (property: { value?: string }) => {
    setEnabled(property?.value === "true");
  };

  useOcProperty({
    resource: "system",
    key: "changeRequestsEnabled",
    onCompleted,
    fetchPolicy: "network-only",
  });

  return {
    isMobile,
    employeeData,
    enabled,
    hasToRefresh,
    timeToRefresh: timeToRefreshValue,
    showRefreshDialog,
    onRefresh,
    currentVersion,
  };
};

export default useOcAppBar;
